import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';
import { Redirect } from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class SigtripLogbookAppLogs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      data: [],
      limit: 100,
      term: '',
      function_name: '',
      http_code: '',
      date_start: '',
      date_finish: '',
      user_id: null,
      modal: false,
      modal_title: '',
      data_modal: '',
    };

    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.authorizePage = this.authorizePage.bind(this);
    this.storeCurrentUser = this.storeCurrentUser.bind(this);
    this.loadData = this.loadData.bind(this);
    this.findLogs = this.findLogs.bind(this);
    this.formatCode = this.formatCode.bind(this);
    this.formatPayload = this.formatPayload.bind(this);
    this.formatResponse = this.formatResponse.bind(this);
    this.formatErrors = this.formatErrors.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleChange(name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      this.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.authorizePage();
  }

  storeCurrentUser(user) {
    var data = JSON.parse(localStorage.getItem("data")) || {};
    data.email = user.email || data.email;
    data.id = user.id;
    localStorage.setItem("data", JSON.stringify(data));
  }

  authorizePage() {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrip') + '/usuario/home', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');

        if (responseJson.data && parseInt(responseJson.data.id, 10) === 10002) { // Somente o usuário admin pode acessar esta página
          self.storeCurrentUser(responseJson.data);
          self.setState({user_id: responseJson.data.id}, function () {
            self.loadData();
          });
          return;
        }

        localStorage.setItem("verify_message", JSON.stringify({
          alert_message: 'Seu usuário não tem permissão para acessar esta página.',
          alert_type: 'error',
        }));

        self.setState({redirect_url: '/'});
      });
    });
  }

  buildPayload() {
    return {
      limit: this.state.limit,
      term: this.state.term,
      function_name: this.state.function_name,
      http_code: this.state.http_code,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
    };
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    var datasave = this.buildPayload();

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrip') + '/logs/logbookapp', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'closed'}});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  findLogs(event) {
    event.preventDefault();
    this.setState({overlay: {message: '', type: '', status: 'open'}});

    var self = this;
    var header = this.refs.request_api.header('application/json');
    var datasave = this.buildPayload();

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigtrip') + '/logs/logbookapp', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'closed'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  formatCode(cell, row) {
    if(row.status_type === 'success'){
      return <span className="label label-success">{cell || 'n/a'}</span>;
    }

    if(row.status_type === 'danger'){
      return <span className="label label-danger">{cell || '0'}</span>;
    }

    return <span className="label label-warning">{cell || 'n/a'}</span>;
  }

  formatPayload(cell) {
    return <button className="btn btn-primary" onClick={() => { this.openModal('Payload', cell); }}>Ver payload</button>;
  }

  formatResponse(cell) {
    return <button className="btn btn-info" onClick={() => { this.openModal('Response', cell); }}>Ver response</button>;
  }

  formatErrors(cell) {
    return <button className="btn btn-danger" onClick={() => { this.openModal('Errors', cell); }}>Ver errors</button>;
  }

  openModal(title, content) {
    var json = content;

    try {
      json = JSON.parse(content);
      json = JSON.stringify(json, null, '\t');
    } catch (e) {
    }

    if(json === null || typeof json === 'undefined' || json === '') {
      json = 'Sem conteúdo';
    }

    this.setState({modal: true, modal_title: title, data_modal: json});
  }

  render() {
    var self = this;

    return (
<div>
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <Topo></Topo>
  <RequestApi ref={'request_api'} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">Logs - Logbook App</h3>
      <hr/>
      <form onSubmit={this.findLogs}>
        <div className="row">
          <div className="col-md-6">
            <label>Busca geral</label>
            <input value={this.state.term} className="form-control" onChange={this.handleChange.bind(this, 'term')} placeholder="E-mail, URL, payload, response ou errors" />
          </div>
          <div className="col-md-3">
            <label>Função</label>
            <input value={this.state.function_name} className="form-control" onChange={this.handleChange.bind(this, 'function_name')} placeholder="Ex.: get_staff_volume_token" />
          </div>
          <div className="col-md-1">
            <label>HTTP</label>
            <input value={this.state.http_code} className="form-control" onChange={this.handleChange.bind(this, 'http_code')} placeholder="200" />
          </div>
          <div className="col-md-2">
            <label>Limite</label>
            <input value={this.state.limit} className="form-control" onChange={this.handleChange.bind(this, 'limit')} placeholder="100" />
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-4">
            <label>Data inicial</label>
            <InputMask value={this.state.date_start} maskChar={null} mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="dd/mm/aaaa" />
          </div>
          <div className="col-md-4">
            <label>Data final</label>
            <InputMask value={this.state.date_finish} maskChar={null} mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="dd/mm/aaaa" />
          </div>
          <div className="col-md-4">
            <label>&nbsp;</label>
            <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> Buscar</button>
          </div>
        </div>
      </form>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há logs cadastrados', defaultSortName: 'id', defaultSortOrder: 'desc', sizePerPage: 100, sizePerPageList: [{text: '10', value: 10}, {text: '25', value: 25}, {text: '50', value: 50}, {text: '100', value: 100}]}} search={true} multiColumnSearch={true} searchPlaceholder='Procurar'>
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} width='80'>ID</TableHeaderColumn>
        <TableHeaderColumn dataField="function" dataAlign="center" dataSort={true} width='220'>Função</TableHeaderColumn>
        <TableHeaderColumn dataField="http_code" dataFormat={this.formatCode} dataAlign="center" dataSort={true} width='110'>HTTP</TableHeaderColumn>
        <TableHeaderColumn dataField="url" dataAlign="center" dataSort={true} width='420'>URL</TableHeaderColumn>
        <TableHeaderColumn dataField="payload" dataFormat={this.formatPayload} dataAlign="center" width='130'>Payload</TableHeaderColumn>
        <TableHeaderColumn dataField="response" dataFormat={this.formatResponse} dataAlign="center" width='140'>Response</TableHeaderColumn>
        <TableHeaderColumn dataField="errors" dataFormat={this.formatErrors} dataAlign="center" width='120'>Errors</TableHeaderColumn>
        <TableHeaderColumn dataField="date" dataAlign="center" dataSort={true} width='170'>Data</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.state.modal_title}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { self.setState({modal: false}) }}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <pre>{this.state.data_modal}</pre>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { self.setState({modal: false}) }}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default SigtripLogbookAppLogs;



// WEBPACK FOOTER //
// ./src/Components/Sigtrip/SigtripLogbookAppLogs.js